import { useContext, useState, useEffect } from 'react';
import { StreamChat } from 'stream-chat';
import { StreamChatContext } from '../components/Dashboard';

export const useStreamChatClient = () => {
  const context = useContext(StreamChatContext);

  if (!context) {
    console.error('NO GET STREAM CONTEXT');
    return;
  }

  return context;
};

export const StreamChatProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [chatClient, setChatClient] = useState<StreamChat | null>(null);
  const value = { chatClient, setChatClient };

  useEffect(() => {
    return () => {
      if (chatClient) chatClient.disconnectUser();
      setChatClient(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StreamChatContext.Provider value={value}>
      {children}
    </StreamChatContext.Provider>
  );
};
